import { HomeCoverage } from '../definitions/InsCommon';


export default HomeCoverage.named('CoverageModel')
    .props({
        personalProperty: 40000,
    })
    .views(self => ({
        get isComplete() {
            return (
                self.personalProperty !== null
                && self.personalLiability !== null
                && self.claimsDeductible !== null
                && self.sewerBackup !== null
                && self.overlandWater !== null
            );
        },
    }));
